import { useEffect } from "react";
import { useAuth } from "../providers/AuthProvider";
import use123zapStore from "../../stores/123zapStore";

export default function SessionBootstrap({ children }) {
  const { isAuthenticated, user } = useAuth();
  const loadPlanoAtual = use123zapStore((state) => state.loadPlanoAtual);
  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";
  const isProfileComplete = String(user?.completeProfile).toLowerCase() === "true";
  const canLoadPrivateContext =
    isAuthenticated && isEmailVerified && isProfileComplete;

  useEffect(() => {
    if (canLoadPrivateContext) {
      loadPlanoAtual(true);
    }
  }, [canLoadPrivateContext, loadPlanoAtual]);

  return children;
}
